<template>
    <modal name="point-status-modal" class="point-status-modal"
           :width="'30%'"
           :height="'auto'"
           @opened="opened"
    >
        <div class="keymodal_title">
      <span class="keymodal_title_txt">
      </span>
            <div class="out_title">상태변경</div>
        </div>
        <div class="pb30">
            <div class="c_table_wrap pt40 text_center">
                <div class="">
                </div>
                <div class="text_left out_table">

                    <el-select class="w_100 mt15"
                               v-model="pbs_status"
                    >
                        <el-option
                            label="상태변경"
                            value=""
                        >
                        </el-option>
                        <el-option
                            v-for="(item, index) in statusList"
                            :key="index"
                            :label="item.name"
                            :value="item.pbs_status"
                        >
                        </el-option>
                    </el-select>
                    <el-input class=" mt3" v-model="pbs_reason" v-if="pbs_status === 2 "></el-input>
                    <div class="input_error" v-if="bb_status === 2">{{ validation.firstError('pbs_reason') }}</div>
                </div>
            </div>
            <div class="text_center pt50">
                <el-button type="info" class="out_btn" @click="closeModal()">취소</el-button>
                <el-button type="info" class="out_btn" @click="statusUpdate()">확인</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import VuxAlert from '@/mixins/alertMixins';
import util from '@/mixins/util';
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import EventBus from "@/mixins/event-bus";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

let params = {};
export default {
    name: "PointStatusModal",
    mixins: [VuxAlert],
    props: {
        getObj: {},
        page: {
            type: Number
        },
    },
    data() {
        return {
            statusList: [
                {
                    pbs_status: 1, name: '보류'
                },
                {
                    pbs_status: 2, name: '거절'
                },
                {
                    pbs_status: 3, name: '승인'
                },
            ],
            pbs_idx: '',
            pbs_reason: '',
            pbs_status: '',
            bb_status: '',
        }
    },
    methods: {
        inData() {
            this.pbs_idx = '';
            this.pbs_reason = '';
            this.pbs_status = '';
        },
        opened() {
            this.inData();
        },

        statusUpdate() {
            let validationArray = ['pbs_status'];
            if (this.pbs_status === 2) {
                validationArray.push('pbs_reason');
            }
            let type = ''
            if(this.pbs_status === 1){
                type = 'hold'
            }
            if(this.pbs_status === 2){
                type = 'deny'
            }
            if(this.pbs_status === 3){
                type = 'approve'
            }

            this.$validate(validationArray).then(async (success) => {
                if (success) {
                    params = {
                        pbs_idx: this.getObj.pbs_idx,
                        pbs_status: this.pbs_status,
                        type:type
                    }
                    if (this.pbs_status === 2) {
                        params.pbs_reason = this.pbs_reason
                    }
                    this.$api.$point.updateStorePointStatus(params).then(res => res.Data.Result).then(res => {
                        if (res.Info.Type === 1) {
                            // this.$root.$emit('get-list', this.page);
                            this.createAlert({
                                title: "포인트 상태",
                                content: "상태변경 완료.",
                                btnText: "확인",
                                hide: () => {
                                    this.closeModal();
                                    EventBus.$emit('getPointList');
                                }
                            });
                        } else {
                            this.createAlert({
                                title: '',
                                content: "변경 실패",
                                btnText: '확인',
                                hide: () => {
                                    this.closeModal();
                                }
                            });
                        }
                    })
                } else {
                    this.errorAlert('입력값을 확인해주세요.')
                }
            });
        },
        closeModal() {
            this.$modal.hide("point-status-modal")
        },
    },
    validators: {
        pbs_status: function (value) {
            return Validator.value(value)
                .required('상태를 선택해주세요.');
        },
        pbs_reason: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi,"");
                        if(content.length === 0) {
                            return '내용을 입력해주세요.'
                        }
                    }
                )
        },
    },
}
</script>

<style scoped>

</style>
